export const isAllowedToPresent = ({
    canControl,
    guestsCanPresent,
    isPresenting,
}: {
    canControl: boolean | undefined;
    guestsCanPresent: boolean | undefined;
    isPresenting: boolean | undefined;
}) => Boolean(canControl || guestsCanPresent || isPresenting);
